import moment from 'moment/moment';

import { DateFormats } from 'constants/common';

import { CalendarActivityEntity, CalendarEvent, CalendarEventEntity } from './types';

export class CalendarEventMapper {
  private static readonly DEFAULT_TIMED_DURATION_MINUTES = 30;

  private static readonly ACTIVITY_DURATION_MINUTES = 15;

  private static parseLocalDate(value: string) {
    return moment(value, DateFormats.IsoDate).toDate();
  }

  public static mapToCalendarEvent(list: CalendarEventEntity[]): CalendarEvent[] {
    return list.map(event => {
      const base = {
        id: event.id,
        title: event.subject,
        allDay: event.allDay,
        priority: event.priority,
        status: event.activityStatus,
        description: event.description ?? null,

        owner: event.owner,
        resourceId: event.owner.id,
        isOwnEvent: event.isOwnEvent,

        sharing: event.sharing,
      };

      if (event.allDay && event.startDate) {
        const start = this.parseLocalDate(event.startDate);

        const end = event.endDate
          ? moment(this.parseLocalDate(event.endDate)).add(1, 'day').toDate()
          : moment(start).add(1, 'day').toDate();

        return {
          ...base,
          start,
          end,
          durationMinutes: moment(end).diff(start, 'minutes'),
        };
      }

      const start = moment(event.startAt ?? event.startDate ?? undefined).toDate();

      const end =
        event.endAt || event.endDate
          ? moment(event.endAt || event.endDate).toDate()
          : moment(start).add(this.DEFAULT_TIMED_DURATION_MINUTES, 'minutes').toDate();

      return {
        ...base,
        start,
        end,
        durationMinutes: moment(end).diff(start, 'minutes'),
      };
    });
  }

  public static mapActivityToCalendarEvent(list: CalendarActivityEntity[]): CalendarEvent[] {
    return list.map(({ id, type, title, description, occurredAt, parentId, parentType }) => {
      const start = moment(occurredAt).toDate();

      return {
        id,
        title,
        start,
        allDay: false,
        description,
        end: moment(start).add(this.ACTIVITY_DURATION_MINUTES, 'minutes').toDate(),
        durationMinutes: this.ACTIVITY_DURATION_MINUTES,
        activity: { type, parentId, parentType },

        color: null,
        isOwnEvent: false,
        sharing: null,
      };
    });
  }
}
